const endpoints = {
  authToken: () => "/sso/gw/interno/token",
  produtos: () =>
    "/gestao-produtos-atd/v1/produtoslegado/produtos/unidades-negocios/DICAP",
  titulos: (produto, oferta) =>
    `/gestao-produtos-atd/v1/ofertalegado/unidades-negocios/DICAP/produtos/${produto}/versoes/${oferta}/ofertas/titulos`,
  cep: (cep) => `/gestao-dados/v1/dne/enderecos/${cep}`,
  profissoes: () =>
    `/estrutura-pessoa/v1/operacoes-profissao/profissoes?unidade=CBO`,
  rendas: () => `/estrutura-pessoa/v1/faixas-renda/origem?origem=corporativo`,
  ufs: () => `/gestao-dados/v1/dominios/unidade-federativa`,
  cotacao: () => `/cotacao-atd/v1/legado/cotacoes/capitalizacao`,
  proposta: () => `/proposta-atd/v1/legado/proposta/capitalizacao`,
};

export default endpoints;
